"use client";
import type { ReactNode } from "react";
import { McpServersProvider } from "../contexts/mcpServersContext";
import { ExtendedThinkingProvider } from "../contexts/extendedThinkingContext";
import { WebSearchProvider } from "../contexts/webSearchContext";
import { WebSearchDomainsProvider } from "../contexts/webSearchDomainsContext";
import { ScopePolicyProvider } from "../contexts/scopePolicyContext";
import { McpServerDateFiltersProvider } from "../contexts/mcpServerDateFiltersContext";

export function ChatSettingsProvider({ children }: { children: ReactNode }) {
  return (
    <McpServersProvider>
      <McpServerDateFiltersProvider>
        <ExtendedThinkingProvider>
          <WebSearchProvider>
            <WebSearchDomainsProvider>
              <ScopePolicyProvider>
                {children}
              </ScopePolicyProvider>
            </WebSearchDomainsProvider>
          </WebSearchProvider>
        </ExtendedThinkingProvider>
      </McpServerDateFiltersProvider>
    </McpServersProvider>
  );
}

export { useMcpServers } from "../contexts/mcpServersContext";
export { useExtendedThinking } from "../contexts/extendedThinkingContext";
export { useWebSearch } from "../contexts/webSearchContext";
export { useWebSearchDomains } from "../contexts/webSearchDomainsContext";
export { useScopePolicy } from "../contexts/scopePolicyContext";
export { useMcpServerDateFilters } from "../contexts/mcpServerDateFiltersContext";
